import React, { useGlobal } from "reactn";
import { Row, Col, Card, Form, Typography, Image, Button, } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { FileProtectOutlined, FieldTimeOutlined } from "@ant-design/icons";

const Dashboard = (props) => {
  let [user, setUser] = useGlobal("user");

  return (
    <div>
      <div className="list-head">
        <div className="list-title">
          <h1>Admin Bilgileri</h1>
        </div>
      </div>
      <div className="form-wrap">
        <Card title={""}>
          <Form layout="horizontal" size={"large"}>
            <Row direction="row">
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10 }} lg={{ span: 10 }} xl={{ span: 6 }} >
                <Image width={200} src={user.profileImageUrl}> </Image>
              </Col>
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 14 }} lg={{ span: 14 }} xl={{ span: 18 }}>
                <Col xs={{ span: 24 }}>
                  <Typography.Title style={{ padding: 0, margin: 0 }}
                    level={2}>{[user.name, user.surname].filter(x => x).join(' ')}</Typography.Title>
                </Col>
                <Col xs={{ span: 24 }}>
                  <Typography.Text>Email : {user.email}</Typography.Text>
                </Col>
                <hr />

                <Row direction="row">
                  <Link to={"/admin/add"}>
                    <Button className="button-consultant" icon={<FieldTimeOutlined />} style={{ marginRight: "10px", marginTop: "10px" }}>Admin Ekle</Button>
                  </Link>
                  <Link to={"/admins"}>
                    <Button className="button-consultant" icon={<FileProtectOutlined />} style={{ marginRight: "5px", marginTop: "10px" }}>Admin Listesi</Button>
                  </Link>
                </Row>

              </Col>
            </Row>
            <hr />
            <Row direction="row">
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 20 }}>
                <Col xs={{ span: 24 }} >
                  <Typography.Title style={{ textAlign: "center" }} level={5} >Login Date : {moment(user.loginDate).format("YYYY-MM-DD HH:mm")}</Typography.Title>
                </Col>
              </Col>
            </Row>
            <hr />
          </Form>
        </Card>
      </div>
    </div>

  );
};

export default Dashboard;
